// extracted by mini-css-extract-plugin
export default {"flex1":"MainMap_flex1__5IHCU","map":"MainMap_map__BHIF5","acronym":"MainMap_acronym__gVx3L"};